import { defineMessages } from 'react-intl';

export const i18n: {
	macroLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorAttachmentNotFound: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	error: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	zoomIn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	zoomOut: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fitToPage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	expandFullscreen: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exitFullscreen: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closeFullscreen: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	presentationMode: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exitPresentationMode: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	previousPage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nextPage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pageCounter: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	macroLabel: {
		id: 'viewpdf-macro.label',
		defaultMessage: 'View PDF',
		description: 'Label for the View PDF macro inserted on a Confluence page.',
	},
	loading: {
		id: 'viewpdf-macro.loading',
		defaultMessage: 'Loading PDF…',
		description: 'Accessible label shown on the spinner while the PDF viewer is loading.',
	},
	errorAttachmentNotFound: {
		id: 'viewpdf-macro.error-attachment-not-found',
		defaultMessage: 'PDF attachment not found. Please check the file name and page parameters.',
		description: 'Error message shown when the specified PDF attachment cannot be located.',
	},
	error: {
		id: 'viewpdf-macro.error',
		defaultMessage: "We're unable to display the PDF. Refresh to try again.",
		description: 'Generic error message displayed when the View PDF macro fails to render.',
	},
	zoomIn: {
		id: 'viewpdf-macro.zoom-in',
		defaultMessage: 'Zoom in',
		description: 'Tooltip for the zoom in button in the PDF viewer toolbar.',
	},
	zoomOut: {
		id: 'viewpdf-macro.zoom-out',
		defaultMessage: 'Zoom out',
		description: 'Tooltip for the zoom out button in the PDF viewer toolbar.',
	},
	fitToPage: {
		id: 'viewpdf-macro.fit-to-page',
		defaultMessage: 'Fit to page',
		description: 'Tooltip for fit to page / reset zoom button',
	},
	expandFullscreen: {
		id: 'viewpdf-macro.expand-fullscreen',
		defaultMessage: 'View fullscreen',
		description: 'Tooltip for the button that expands the PDF viewer to fullscreen.',
	},
	exitFullscreen: {
		id: 'viewpdf-macro.exit-fullscreen',
		defaultMessage: 'Exit fullscreen',
		description: 'Tooltip for the button that exits the PDF viewer fullscreen mode.',
	},
	closeFullscreen: {
		id: 'viewpdf-macro.close-fullscreen',
		defaultMessage: 'Close',
		description: 'Tooltip for close button in fullscreen overlay',
	},
	presentationMode: {
		id: 'viewpdf-macro.presentation-mode',
		defaultMessage: 'Presentation mode',
		description: 'Tooltip for button that enters presentation/fullscreen mode',
	},
	exitPresentationMode: {
		id: 'viewpdf-macro.exit-presentation-mode',
		defaultMessage: 'Exit presentation mode',
		description: 'Tooltip for exit presentation mode button',
	},
	previousPage: {
		id: 'viewpdf-macro.previous-page',
		defaultMessage: 'Previous page',
		description: 'Tooltip for previous page button in presentation mode',
	},
	nextPage: {
		id: 'viewpdf-macro.next-page',
		defaultMessage: 'Next page',
		description: 'Tooltip for next page button in presentation mode',
	},
	pageCounter: {
		id: 'viewpdf-macro.page-counter',
		defaultMessage: '{currentPage} / {totalPages}',
		description: 'Page counter label showing current page and total pages in presentation mode',
	},
});
